var map = {
	"./axe/adamantite-cropped.png": 8603,
	"./axe/crystal-cropped.png": 6445,
	"./axe/infernium-cropped.png": 7163,
	"./axe/steel-cropped.png": 8889,
	"./axe/stone-cropped.png": 2481,
	"./crossbow/adamantite-cropped.png": 5406,
	"./crossbow/crystal-cropped.png": 2269,
	"./crossbow/infernium-cropped.png": 8570,
	"./crossbow/steel-cropped.png": 9884,
	"./crossbow/stone-cropped.png": 4189,
	"./pickaxe/adamantite-cropped.png": 8285,
	"./pickaxe/crystal-cropped.png": 77,
	"./pickaxe/infernium-cropped.png": 1808,
	"./pickaxe/steel-cropped.png": 3402,
	"./pickaxe/stone-cropped.png": 8744,
	"./rod/adamantite-cropped.png": 6013,
	"./rod/crystal-cropped.png": 4317,
	"./rod/infernium-cropped.png": 9604,
	"./rod/steel-cropped.png": 6932,
	"./rod/stone-cropped.png": 4711,
	"./sickle/adamantite-cropped.png": 7887,
	"./sickle/crystal-cropped.png": 4003,
	"./sickle/infernium-cropped.png": 3225,
	"./sickle/steel-cropped.png": 3859,
	"./sickle/stone-cropped.png": 9459,
	"./sword/adamantite-cropped.png": 4963,
	"./sword/crystal-cropped.png": 4547,
	"./sword/infernium-cropped.png": 7280,
	"./sword/steel-cropped.png": 9383,
	"./sword/stone-cropped.png": 7837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9247;